/* eslint-disable @typescript-eslint/no-unused-vars */
import { Result, Steps } from 'antd';
import getFormatMessage from '../../../../../locales/get-format-message';
import {
  IAPICanOpenInvoiceBillItem,
  IAPICompanyFullInfo,
  IAPIFeeCenterMailManageItem,
  IAPIInvoiceHeader,
  IAPIStudioMemberHasPermissionItem,
} from '../../../../../model/api-modules';
import { InvoicePreview } from './preview';
import styles from './index.module.scss';
import { useState } from 'react';
import { CommonCard } from '../../../../../components/card';
import { GetformatMoney } from '../../billing-overview/component/fomat-money';
import { AutoTable } from '../../../../../components/auto-table';
import { CommonSelect } from '../../../../../components/select';
import { AddModifyInvoiceDrawer, HeaderForm } from '../header/drawer';
import { HeaderTypeForm } from './type-form';
import {
  IInvoiceBodyData,
  IInvoiceTypeData,
  InvoiceShow,
} from '../../../../../model/billing-center';
import {
  CommonButton,
  CommonButtonGroup,
  MainButton,
} from '../../../../../components/button/main';
import { useHistory } from 'react-router';
import { applyInvoice } from '../../../../../api/billing-center/invoice';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../../store/reducers';
import { parseJson } from '../../../../../lib';
import { messageError } from '../../../../../components/message';
import { CommonResult } from '../../../../../components/result';
import { goInvoicePage } from '../lib';
import moment from 'moment';
interface IProps {
  readonly selectBills: ReadonlyArray<IAPICanOpenInvoiceBillItem>;
  readonly invoice: IAPIInvoiceHeader;
  readonly emails: ReadonlyArray<IAPIFeeCenterMailManageItem>;
  readonly companyInfo: IAPICompanyFullInfo;
  readonly owner: IAPIStudioMemberHasPermissionItem;
  readonly onReload: (
    emails: IAPIFeeCenterMailManageItem[],
    header: IAPIInvoiceHeader
  ) => void;
}

enum ApplyStep {
  Confirm,
  Preview,
  Submit,
}

export const ApplyInvoice = (props: IProps) => {
  const { invoice, emails, selectBills, companyInfo, owner, onReload } = props;
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );

  const [submitting, setSubmitting] = useState<boolean>(false);
  const [showInvoiceDrawer, setShowInvoiceDrawer] = useState<boolean>(false);
  const totalAmount = selectBills.reduce(
    (acc, item) => acc + Number(item.amount),
    0
  );
  const taxRate = selectBills[0]?.tax_rate;
  const history = useHistory();
  const [step, setStep] = useState<number>(ApplyStep.Confirm);
  const [invoiceBodyData, setInvoiceBodyData] = useState<IInvoiceBodyData>({
    name: '技术服务',
    type: '空白',
    unit: '套',
    number: 1,
    amount: Number((totalAmount / 1.06).toFixed(2)),
    taxRate,
    tax: Number(
      (totalAmount - Number((totalAmount / 1.06).toFixed(2))).toFixed(2)
    ),
  });
  const [invoiceTypeData, setInvoiceTypeData] = useState<IInvoiceTypeData>({
    email: emails[0]?.email,
    show_buyer: InvoiceShow.Hide,
    show_seller: InvoiceShow.Hide,
    remark: '',
  });

  const submit = async () => {
    if (!selectStudio) {
      return;
    }
    const companyMdmInfo = parseJson(companyInfo.MDMCertificationInfo);
    if (!companyMdmInfo) {
      return;
    }
    setSubmitting(true);
    const res = await applyInvoice({
      invoice_id: invoice.invoice_id, // 抬头id
      studio_id: selectStudio.studioID,
      consume_ids: selectBills.map((item) => item.consume_id).join(),
      currency_code: 'CNY',
      invoice_month: moment(selectBills[0].create_time).format('YYYY-MM'),
      mdm_id: companyMdmInfo.customerId,
      mdm_name: companyMdmInfo.customerName,
      email: invoiceTypeData.email || '',
      unit: invoiceBodyData.unit,
      make_out_item: invoiceBodyData.name,
      specification:
        invoiceBodyData.type === '空白' ? '' : invoiceBodyData.type,
      remark: invoiceTypeData.remark || '',
      show_buyer: invoiceTypeData.show_buyer,
      show_seller: invoiceTypeData.show_seller,
    });
    if (!res) {
      messageError('提交申请失败');
      setSubmitting(false);
      return;
    }
    setSubmitting(false);
    setStep(ApplyStep.Submit);
  };

  const renderStep = () => {
    if (step !== ApplyStep.Submit) {
      return (
        <div className={styles.applyStep}>
          <Steps
            items={[
              {
                title: getFormatMessage('invoice_confirm'),
                status: step === ApplyStep.Confirm ? 'process' : 'wait',
              },
              {
                title: getFormatMessage('invoice_preview'),
                status: step === ApplyStep.Preview ? 'process' : 'wait',
              },
              {
                title: getFormatMessage('apply_submit_btn'),
              },
            ]}
          />
        </div>
      );
    }
  };

  const renderContent = () => {
    if (step === ApplyStep.Confirm) {
      return (
        <>
          <CommonCard
            title={
              <>
                <span className={styles.moneyLabel}>
                  {getFormatMessage('apply_total_invoice_amount')}：
                </span>
                <GetformatMoney
                  money={String(totalAmount)}
                  className={styles.moneyText}
                />
              </>
            }
          >
            <AutoTable
              list={[invoiceBodyData]}
              configFields={[
                {
                  key: 'name',
                  name: getFormatMessage('apply_item_name'),
                  tableExtension: {
                    width: 200,
                  },
                },
                {
                  key: 'type',
                  name: getFormatMessage('apply_specification_model'),
                  tableExtension: {
                    width: 200,
                    renderRow(key, value, row) {
                      return (
                        <CommonSelect
                          value={value}
                          onChange={(val) => {
                            setInvoiceBodyData({
                              ...invoiceBodyData,
                              type: val,
                            });
                          }}
                          options={[
                            {
                              label: '空白',
                              value: '空白',
                            },
                            {
                              label: '无',
                              value: '无',
                            },
                          ]}
                        />
                      );
                    },
                  },
                },
                {
                  key: 'unit',
                  name: getFormatMessage('apply_unit'),
                  tableExtension: {
                    width: 200,
                    renderRow(key, value, row) {
                      return (
                        <CommonSelect
                          value={value}
                          onChange={(val) => {
                            setInvoiceBodyData({
                              ...invoiceBodyData,
                              unit: val,
                            });
                          }}
                          options={[
                            {
                              label: '套',
                              value: '套',
                            },
                            {
                              label: '项',
                              value: '项',
                            },
                            {
                              label: '年',
                              value: '年',
                            },
                            {
                              label: '次',
                              value: '次',
                            },
                          ]}
                        />
                      );
                    },
                  },
                },
                {
                  key: 'number',
                  name: getFormatMessage('apply_quantity'),
                },
                {
                  key: 'amount',
                  name: getFormatMessage('apply_unit_price'),
                },
                {
                  key: 'amount',
                  name: getFormatMessage('apply_amount'),
                },
                {
                  key: 'taxRate',
                  name: getFormatMessage('apply_tax_rate'),
                },
                {
                  key: 'tax',
                  name: getFormatMessage('apply_tax_amount'),
                },
              ]}
            />
          </CommonCard>
          <CommonCard
            className={styles.headCard}
            title={getFormatMessage('invoice_header_title')}
            extra={
              <CommonButton onClick={() => setShowInvoiceDrawer(true)}>
                {getFormatMessage('apply_modify')}
              </CommonButton>
            }
          >
            <HeaderForm className={styles.headerForm} invoiceInfo={invoice} />
          </CommonCard>
          <CommonCard title={getFormatMessage('invoice_type')}>
            <HeaderTypeForm
              emails={emails}
              onChange={(data, newEmails) => {
                setInvoiceTypeData(data);
                onReload(newEmails, invoice);
              }}
              values={invoiceTypeData}
              owner={owner}
            />
          </CommonCard>
        </>
      );
    }
    if (step === ApplyStep.Preview) {
      return (
        <>
          <InvoicePreview
            invoiceType={invoice.invoice_type}
            buyerName={invoice.invoice_name}
            buyerCode={invoice.identification_code}
            buyerBank={invoice.open_bank}
            buyerBankCode={invoice.open_account}
            amount={totalAmount}
            remark={invoiceTypeData.remark}
            unit={invoiceBodyData.unit}
            spec={invoiceBodyData.type}
            showBuyer={invoiceTypeData.show_buyer === InvoiceShow.Show}
            showSeller={invoiceTypeData.show_seller === InvoiceShow.Show}
          />
        </>
      );
    }
    if (step === ApplyStep.Submit) {
      return (
        <CommonResult
          status="success"
          title={getFormatMessage('invoice_have_apply')}
          subTitle={getFormatMessage('invoice_view_in_email')}
          extra={[
            <MainButton
              onClick={() => {
                gotoPage();
              }}
            >
              {getFormatMessage('back')}
            </MainButton>,
          ]}
        />
      );
    }
  };

  const gotoPage = (page = '') => {
    if (!selectStudio) {
      return;
    }
    history.push(`/studio/${selectStudio.studioID}/fee/invoice-manage/${page}`);
  };

  const renderFooterButtons = () => {
    if (step === ApplyStep.Confirm) {
      return (
        <CommonButtonGroup>
          <MainButton onClick={() => setStep(ApplyStep.Preview)}>
            {getFormatMessage('apply_next_btn')}
          </MainButton>
          <CommonButton
            onClick={() => {
              gotoPage();
            }}
          >
            {getFormatMessage('cancel')}
          </CommonButton>
        </CommonButtonGroup>
      );
    }
    if (step === ApplyStep.Preview) {
      return (
        <CommonButtonGroup>
          <MainButton loading={submitting} onClick={submit}>
            {getFormatMessage('apply_submit_btn')}
          </MainButton>
          <CommonButton onClick={() => setStep(ApplyStep.Confirm)}>
            {getFormatMessage('apply_back_btn')}
          </CommonButton>
        </CommonButtonGroup>
      );
    }
  };

  return (
    <div className={styles.applyPage}>
      {renderStep()}
      {renderContent()}
      {renderFooterButtons()}
      {showInvoiceDrawer && (
        <AddModifyInvoiceDrawer
          defaultEdit={true}
          companyInfo={companyInfo}
          invoiceInfo={invoice}
          onClose={() => {
            setShowInvoiceDrawer(false);
          }}
          onChange={(newInfo) => {
            onReload([...emails], newInfo);
            setShowInvoiceDrawer(false);
          }}
        />
      )}
    </div>
  );
};
